import React from "react";
import "./DrawerContent.css";

export default function FAQ() {
   return <div className='drawerContent'>Content to be decided later</div>;
}
